import { render, staticRenderFns } from "./ConfigDirectMatchPrograms.vue?vue&type=template&id=01bbbdf9&scoped=true&"
import script from "./ConfigDirectMatchPrograms.vue?vue&type=script&lang=js&"
export * from "./ConfigDirectMatchPrograms.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDirectMatchPrograms.vue?vue&type=style&index=0&id=01bbbdf9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bbbdf9",
  null
  
)

export default component.exports